import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { logout } from '../../redux/actions/auth';

class Logout extends Component {
    componentDidMount () {
        window.scrollTo(0, 0);
        this.props.onLogout();
    }

    render () {
        return <Navigate to="/sign-in" replace />;
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onLogout: () => dispatch(logout())
    };
};

export default connect(null, mapDispatchToProps)(Logout);